import { render, staticRenderFns } from "./item_description.vue?vue&type=template&id=a28f9f5c&"
import script from "./item_description.vue?vue&type=script&lang=js&"
export * from "./item_description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports